import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

const TestPanel = ({ chatMessages, onSendMessage, onReset, onClose }) => {
  const { t } = useTranslation();
  const [message, setMessage] = useState('');

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (message.trim()) {
      onSendMessage(message);
      setMessage('');
    }
  };

  return (
    <div className="absolute bottom-4 left-4 z-10 bg-white p-4 rounded-md shadow-lg border border-gray-200 w-96 h-1/2 flex flex-col">
      <div className="flex justify-between items-center mb-2">
        <p className="font-bold">{t('testConversation')}</p>
        <div>
          <button
            onClick={onReset}
            className="text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 px-2 py-1 rounded mr-2"
          >
            {t('reset')}
          </button>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
      <div className="flex-grow overflow-y-auto mb-2 p-2 bg-gray-50 rounded">
        {chatMessages.map((chat, index) => (
          <div key={index} className={`mb-2 p-2 rounded-lg max-w-xs ${
            chat.sender === 'user'
              ? 'bg-blue-500 text-white self-end ml-auto'
              : 'bg-gray-300 text-black self-start mr-auto'
          }`}>
            {chat.text}
          </div>
        ))}
      </div>
      <form onSubmit={handleSendMessage}>
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full rounded-md border border-gray-300 p-2"
          placeholder={t('typeYourMessage')}
        />
        <button
          type="submit"
          className="mt-2 w-full rounded-md bg-green-500 px-4 py-2 text-white"
        >
          {t('send')}
        </button>
      </form>
    </div>
  );
};

export default TestPanel;
